export default {
  common: {
    currentLanguage: 'The current language is \'{{lng}}\'',
    email: 'Email',
    password: 'Mot de passe',
    edit: 'Éditer',
    update: 'Modifier',
    cancel: 'Annuler',
    delete: 'Supprimer'
  },
  home: {
    logout: 'Déconnexion'
  },
  auth: {
    notRegistered: 'Pas inscrit?',
    forgotPassword: 'J\'ai perdu mon mot de passe',
    forgotPasswordContent: 'Entrez votre email GOWOD, un mot de passe temporaire vous sera envoyé afin de vous permettre de vous connecter.\nPensez à le changer par la suite depuis les réglages de l\'application.',
    localstorageError: 'Il semblerait que les cookies soient bloqués sur votre navigateur. Ce site les utilise uniquement pour le stockage de données d\'authentification, veuillez activer les cookies.',
    signIn: 'Connexion',
    modal: {
      title: 'L\'inscription à GOWOD se fait depuis l\'application mobile',
      content: 'L\'application est disponible pour Android et iOS'
    },
    signinFacebook: "Connexion avec Facebook",
    signinGoogle: "Connexion avec Google",
  },
  tabs: {
    profile: 'Profil',
    pdata: 'Données personnelles',
    premium: 'GOWOD Premium',
    gifts: 'Cartes cadeau'
  },
  profile: {
    firstname: 'Prénom',
    lastname: 'Nom',
    age: 'Age',
    sex: 'Sexe',
    affiliate: 'Affiliée',
    country: 'Pays',
    birthdate: 'Date de naissance'
  },
  sex: {
    MALE: 'Homme',
    FEMALE: 'Femme',
    OTHER: 'Autres'
  },
  pdata: {
    title: 'Les données personnelles récoltées par GOWOD pour son bon fonctionnement sont:',
    part1: 'Les données du profil: nom, prénom, age, sexe, box affiliée et pays',
    part2: 'Les résultats des tests de mobilité: réponses, scores, profil configuré',
    part3: 'Les protocoles générés pour usage statistique: date, durée choisie, type (pre/post WOD, quotidien) et les mouvements sélectionnés',
    manage: 'GESTION DES DONNÉES',
    download: 'Télécharger mes données',
    delete: 'Supprimer mon compte',
    deleteModal: {
      title: 'Suppression de compte GOWOD',
        part1: 'Êtes vous sûr de vouloir supprimer votre compte GOWOD?',
        part2: 'Cette action supprimera votre compte de façon',
        part3: 'définitive et irréversible',
        part4: 'Note: Si vous êtes abonné depuis iTunes, la suppression de votre compte ne VOUS DÉSABONNERA PAS.',
        part5: 'Suivez ce lien pour vous aider à vous désabonner d\'iTunes'
    }
  },
  promoTuto: {
    line1: 'Comment utiliser votre code « COMMUNITY »?',
    line2: '40 JOURS D\'ESSAI GRATUIT',
    step1: "Choisissez une des offres ci-dessous",
    step2: 'Cliquez sur s\'abonner',
    step3: 'Cliquez sur "J\'ai un promocode" (présent uniquement au premier abonnement)',
    step4: 'Entrez votre promocode: COMMUNITY',
    step51: 'Annulez n\'importe quand avant la fin de la période d\'essai',
    step52: 'pour ne pas être facturé',
    step53: "si vous ne voulez pas continuer",
    warning: "Attention: Offre valable uniquement sur votre première inscription"
  },
  premium: {
    authenticatePayment: "Authentifier le paiement",
    seeInvoice: "Résoudre le problème",
    premiumUnlocks: 'GOWOD Premium vous donne accès au test de mobilité mensuel qui vous permettra de déterminer l\'axe de mobilité le plus rentable à améliorer pour vous, ainsi qu\'à l\'ensemble des protocoles de mobilité PRE-WOD POST-WOD et Quotidiens, configurés sur votre point faible afin de vous faire progresser efficacement.',
    premiumSlogan: 'La mobilité facilitée et personnalisée pour vous',
    point1: 'Améliorez vos performances en WOD',
    point2: 'Facilitez l\'acquisition d\'une technique optimale',
    point3: 'Optimisez votre transfert de force',
    point4: 'Accélérez votre récupération',
    point5: 'Réduisez le risque de blessure',
    freeTrial: '14 jours d\'essai gratuit pour toute première inscription',
    monthly: ' Mensuel',
    halfYearly: 'Semestriel',
    yearly: ' Annuel',
    subscribe: 'S\'abonner',
    perMonth: '/ mois',
    per6Months: '/ 6 mois',
    perYear: '/ an',
    subscriptionFrom: 'Abonné depuis',
    pausedUntil: 'Abonnement en pause jusqu\'au',
    nextBilling: 'Prochaine facturation',
    changePlan: 'Changer de plan',
    confirm: 'Confirmer',
    reactivateSub: 'Réactiver l\'abonnement',
    unpauseSub: 'Reprendre l\'abonnement',
    unpauseText: 'Vous êtes sur le point de relancer votre abonnement, redémarrez l\'application GOWOD une fois fait pour récupérer l\'accès à GOWOD Premium.',
    unpause: 'Reprendre',
    break: 'Vous pouvez faire une pause à la place!',
    pauseFor: 'Pause de votre compte pour:',
    oneMonth: '1 Mois',
    twoMonths: '2 Mois',
    threeMonths: '3 Mois',
    pauseText: 'Vous ne serez pas facturé pendant votre pause, votre abonnement et l\'accès à GOWOD Premium reprendra à la fin de cette période. Vous pouvez également reprendre l\'abonnement quand vous le souhaitez.',
    pauseSub: 'Suspendre mon abonnement',
    noThanks: 'Non merci, me désabonner',
    month: 'mois',
    promocode: 'Code promo',
    signupDate: 'Date d\'abonnement',
    accessUntil: 'Accès jusq\'au',
    firstBilling: 'Première facturation',
    currentPeriod: 'Période courante',
    status: 'Status',
    cancelAtEnd: 'Annulé à la fin de la période courante',
    changePlanTitle: 'Changer de plan de facturation',
    changePlanContent: "Si vous êtes en période d'essai, elle sera conservée et votre nouveau plan de facturation commencera à la date de fin de celle-ci.\nSinon, votre abonnement va changer de plan dès maintenant et vous serez facturé la différence entre les deux plans en tenant compte de la période utilisée sur l'ancien plan.",
    statuses: {
      active: 'Actif',
      trialing: 'Période d\'essai en cours',
      past_due: 'Problème de paiement',
      unpaid: 'Problème de paiement',
      incomplete: 'Authentification nécessaire'
    },
    updateCC: 'Mettre à jour la carte de crédit',
    updateModal: {
      title: 'Mise à jour de la carte de crédit',
      content: 'Veuillez saisir les informations de votre nouvelle carte:'
    },
    unsubscribe: 'Se désabonner',
    successModal: {
      title: "Inscription réussie!",
      part1: "Felicitations, vous êtes désormais membre GOWOD Premium!",
      part2: "Fermez et réouvrez votre application GOWOD pour que votre accès Premium soit pris en compte."
    },
    unsubModal: {
      title: 'Nous sommes tristes de vous voir partir...',
      part1: 'Pourriez-vous prendre un moment pour nous aider à nous améliorer en nous disant pourquoi vous partez?',
      mail: 'Si vous avez un problème vous pouvez nous envoyer directement un email à ',
      part2: 'Vous aurez accès à GOWOD Premium jusqu\'à la fin de la période réglée.',
      confirm: 'Confirmer',
      reason1: "Je ne l'utilise pas assez",
      reason2: "Trop cher",
      reason3: "Ce n'est pas assez efficace",
      reason4: "Autre",
      addon: "Quelque chose à nous dire? (Optionnel)"
    },
    storesModal: {
      title: 'Désinscription depuis les stores',
      part1: 'Il semblerait que votre inscription à GOWOD Premium aie été réalisée à travers un des stores.',
      part2: 'Vous pouvez vous désabonner depuis le store correspondant à votre plateforme.',
      part3: 'Vous pouvez consulter ces liens si vous avez besoin d\'aide:',
    },
    subscribeModal: {
      title: 'Abonnement à GOWOD Premium',
      havePromocode: 'J\'ai un code promo',
      validate: 'Valider',
      invalidCode: 'Code invalide',
      validCode1: 'Code valide',
      validCode2: 'jours d\'essai',
    },
    promocodeModal: {
      link: 'J\'ai un code promo',
      title: 'Utilisation d\'un code promo',
      intro: "Les codes promo permettent d'allonger la période d'essai de l'inscription à GOWOD Premium.",
      intro2: "Ils sont utilisables uniquement lors de votre première souscription.",
      step1: "Choisissez la facturation souhaitée (mensuelle ou semestrielle) et cliquez sur le bouton correspondant",
      step2: "La pop up d'inscription s'ouvre et si il s'agit de votre premier abonnement, activez l'interrupteur code promo",
      step3: "Saisissez votre code dans le champ, et validez le à l'aide du bouton",
      step4: "Si votre code est valide vous verrez apparaitre un message de validation confirmant la durée de la période d'essai",
      step5: "Vous pouvez maintenant remplir vos données de paiement et continuer votre inscription"
    }
  },
  messages: {
    welcome: 'Bienvenue {{firstname}}',
    error: 'Une erreur est survenue',
    updateOK: 'Mise à jour réussie!',
    updateKO: 'Une erreur est survenue lors de la mise à jour du profil',
    subscribeOK: 'Inscription à GOWOD Premium réussie!',
    subscribeKO: 'Une erreur est survenue lors de l\'inscription au premium',
    cardInvalid: 'Carte invalide',
    cardUpdateOK: 'Mise à jour de la carte réussie',
    cardUpdateKO: 'Une erreur est survenue lors de la mise à jour de la carte',
    cancelOK: 'Annulation de l\'abonnement réussie',
    cancelKO: 'Une erreur est survenue lors de l\'annulation de l\'abonnement',
    premiumInfoKO: 'Une erreur est survenue lors de la récupération des informations premium',
    deleteKO: 'Une erreur est survenue lors de de la récupération de vos données personelles',
    pdataKO: 'Une erreur est survenue lors de l\'effacement de votre compte',
    wrongCardData: 'Données de carte invalides',
    pauseOK: 'Abonnement mis en pause',
    resetOK: 'Mot de passe temporaire envoyé'
  },
  giftCards: {
    noiTunes: 'Un code cadeau est de la forme XXXX-XXXX-XXXX, veuillez noter que si vous êtes inscrit à travers iTunes ou Google Play, le code n\'aura aucun effet.<br/>Pour connaître la procédure à suivre pour passer d\'iTunes à notre site web, veuillez envoyer un email à <strong style="color:#6499FF">help@gowod.eu</strong>',
    enterCode: 'Pour utiliser votre carte cadeau, veuillez entrer le code:',
    successMessage: 'Votre catre cadeau a été appliquée! Redémarrez l\'application et vous devriez maintenant avoir accès à GOWOD Premium.',
    redeem: 'Appliquer'
  }
}


// WEBPACK FOOTER //
// ./src/languages/fr.js